import {baseApi} from './baseApi';

export const injectedActionTrackerApi = baseApi.injectEndpoints({
    addTagTypes: ['ActionTracker'],
    endpoints: (builder) => ({
        getActionTracker: builder.query({
            query: (args) => {
                let {projectId} = args;
                return {url: 'getActionTracker?project_id='+ projectId};
            },
            providesTags: ['ActionTracker']
        })
    }),
});

export const {
    useGetActionTrackerQuery,
} = injectedActionTrackerApi;
